import type { ImpactReportPhase } from "../../types/impactReportPhase";
import { impactReportPhaseMap } from "../../types/impactReportPhase";
import { industryTransitionKeys } from "../../utils/i18n";

type PhaseChrome = {
    /** The header carries the only close control, so it stays for every phase except the uncancellable write. */
    readonly showsHeader: boolean;
    readonly showsFooter: boolean;
    /** `aria-busy` — true only while a request is in flight, never on an error or a settled screen. */
    readonly isBusy: boolean;
    readonly announcementKey: string;
};

/**
 * One exhaustive table keyed by phase, so a seventh phase is a compile error at every consumer at once
 * rather than a forgotten branch. Read against the pre-fix code it is three corrections: the load-error
 * screen keeps its footer no longer, and `aria-busy` (was bound to `!report`) is now right in both the
 * enrolling and load-error directions.
 */
export const PHASE_CHROME: Record<ImpactReportPhase, PhaseChrome> = {
    [impactReportPhaseMap.loading]: {
        showsHeader: true,
        showsFooter: true,
        isBusy: true,
        announcementKey: industryTransitionKeys.announceLoading,
    },
    [impactReportPhaseMap.ready]: {
        showsHeader: true,
        showsFooter: true,
        isBusy: false,
        announcementKey: industryTransitionKeys.announceReady,
    },
    [impactReportPhaseMap.loadError]: {
        showsHeader: true,
        showsFooter: false,
        isBusy: false,
        announcementKey: industryTransitionKeys.announceLoadError,
    },
    [impactReportPhaseMap.enrolling]: {
        showsHeader: false,
        showsFooter: false,
        isBusy: true,
        announcementKey: industryTransitionKeys.announceEnrolling,
    },
    [impactReportPhaseMap.success]: {
        showsHeader: true,
        showsFooter: false,
        isBusy: false,
        announcementKey: industryTransitionKeys.announceSuccess,
    },
    [impactReportPhaseMap.enrollError]: {
        showsHeader: true,
        showsFooter: false,
        isBusy: false,
        announcementKey: industryTransitionKeys.announceEnrollError,
    },
};
